"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _escapeRegExp = _interopRequireDefault(require("lodash/escapeRegExp"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const matchString = function (match, str) {
  let ignoreNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  let simpleSplit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  // Simple regex split -- this is default behaviour
  const regexSimple = new RegExp(`${match.split(/(\s+)/).filter(h => h.trim()).map(hl => '(' + (0, _escapeRegExp.default)(hl) + ')').join('|')}`, 'gi');

  // Split Elivis "The King" Presley into [Elvis, The King, Presley]
  const regex = new RegExp(`${match.split(/(?!\B"[^"]*)\s+(?![^"]*"\B)/).filter(h => h.trim()).map(quotedSection => {
    if (quotedSection.charAt(0) === '"' && quotedSection.charAt(quotedSection.length - 1) === '"') {
      return quotedSection.slice(1, quotedSection.length - 1);
    }
    return quotedSection;
  }).map(hl => '(' + (0, _escapeRegExp.default)(hl) + ')').join('|')}`, 'gi');
  if (ignoreNull && !match) {
    const nullRegex = /a^/gi; // Should match nothing

    return [[str], nullRegex];
  }
  if (simpleSplit) {
    return [str.split(regexSimple)?.filter(s => s && s.trim()), regexSimple];
  }
  return [str.split(regex)?.filter(s => s && s.trim()), regex];
};
var _default = exports.default = matchString;